import { render, staticRenderFns } from "./ListTypeWebhookView.vue?vue&type=template&id=3581b6fd&"
import script from "./ListTypeWebhookView.vue?vue&type=script&lang=ts&"
export * from "./ListTypeWebhookView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports